import { JSX } from "react";
import Stepper from "./Stepper";

type StepperProps = {
  onBack: () => void;
  buttonType?: ButtonType;
  disabled?: boolean;
  loading: boolean;
  steps?: string[];
  step?: string;
  showSkip?: boolean;
};

export type StepperType = (props: PassedStepperProps) => JSX.Element;

type PassedStepperProps = {
  loading?: boolean;
  disabled?: boolean;
  showSkip?: boolean;
};

type ButtonType = "next" | "finish" | "start" | "close";

export default function StepperWrapper({
  onBack,
  buttonType,
  disabled,
  loading,
  showSkip,
  step,
  steps,
}: StepperProps) {
  const buttonText =
    buttonType ||
    ((steps || []).indexOf(step || "") === 0 // If on the first step
      ? "start"
      : (steps || []).indexOf(step || "") === (steps || []).length - 2 // If on the second-to-last step
        ? "finish"
        : "next"); // Otherwise, somewhere in the middle
  return (
    <Stepper
      onBack={onBack}
      buttonType={buttonText}
      disabled={disabled}
      loading={loading}
      step={step}
      steps={steps}
      showSkip={showSkip}
    />
  );
}
